module.exports = __webpack_public_path__ + "static/img/rail-text-3.f42eea42.png";